import { fr } from './fr';
import { en } from './en';
import { es } from './es';

export const translations = {
  fr,
  en,
  es,
};

export type SupportedLanguage = keyof typeof translations;

export const supportedLanguages: { code: SupportedLanguage; name: string; flag: string }[] = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
];

// Helper function to get locale code from language
export const getLocaleFromLanguage = (lang: SupportedLanguage): string => {
  const locales: Record<SupportedLanguage, string> = {
    fr: 'fr-FR',
    en: 'en-US',
    es: 'es-ES',
  };
  return locales[lang];
};

// Helper function to capitalize first letter
export const capitalizeFirstLetter = (str: string): string => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};

// Helper function to format date with capitalized month
export const formatDate = (
  date: Date,
  locale: string,
  options: Intl.DateTimeFormatOptions
): string => {
  const formatted = date.toLocaleDateString(locale, options);
  return capitalizeFirstLetter(formatted);
};